<template>
<div class="project-engagement-manager-lock-wrapper" v-if="typeof project == 'object' && project.engagement_manager && getSystemSetting('project__show_engagement_manager') && getSystemSetting('project__engagement_manager_lock')">
                	<button v-if="project.engagement_manager_locked" v-b-tooltip.hover title="Unlock to automatically set the engagement manager when the department for the project changes." class="btn btn-icon" @click="doToggleProjectEngagementManagerLock(project.id)"><i class="icomoon-lock-solid" ></i></button>
                	<button v-if="!project.engagement_manager_locked" v-b-tooltip.hover title="Lock to prevent the engagement manager from changing when the department for the project is changed" class="btn btn-icon" @click="doToggleProjectEngagementManagerLock(project.id)"><i class="icomoon-unlock"></i></button>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props:["project"],
    data() {
        return {
            addEngagementManagerFlag: false,
        };
    },
    computed: {
        ...mapGetters(["allUsers", "userAbilities", "allActiveUsers","getSystemSetting"]),

        userCanEditProject() {
			const userId = localStorage.getItem("userId");
            const project = this.project;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
    },
    methods: {
        ...mapActions(["toggleProjectEngagementManagerLock"]),
        outside() {
            this.$set(this, "addEngagementManagerFlag", false);
        },
        doToggleProjectEngagementManagerLock(project_id) {
        	let payload = {
        	  projectId: project_id,
        	};
          this.toggleProjectEngagementManagerLock(payload);
        },


    },
}

</script>